import {
  WHEELTRAILERTAIL_PUT,
  WHEELTRAILERTAIL_GET,
  WHEELTRAILERTAIL_POST,
  WHEELTRAILERTAIL_ALL,
  WHEELTRAILERTAIL_DELETE,
  WHEELTRAILERTAIL_LOADING,
  WHEELTRAILERTAIL_ERROR,
} from '../types';

import api from '../../../utils/functions/api';

export const wheelTrailerTailCreate = (payload) => async (dispatch) => {
  try {
    dispatch({ type: WHEELTRAILERTAIL_LOADING });
    const { data } = await api.post(
      `${process.env.REACT_APP_API_URL}/wheel-maintenance-trailer`,
      {
        ...payload,
      },
    );
    dispatch({ type: WHEELTRAILERTAIL_POST, payload: data });
  } catch (error) {
    console.error(error);
    dispatch({ type: WHEELTRAILERTAIL_ERROR });
  }
};

export const wheelTrailerTailAll = (params) => async (dispatch) => {
  try {
    const { name = '', size = '', page = 1 } = params;
    const { data, status } = await api.get(
      `${process.env.REACT_APP_API_URL}/wheel-maintenance-trailer?name=${name}&size=${size}&page=${page}`,
    );
    if (status === 200) {
      dispatch({ type: WHEELTRAILERTAIL_ALL, payload: data });
    }
  } catch (error) {
    console.error(error);
    dispatch({ type: WHEELTRAILERTAIL_ERROR });
  }
};

export const wheelTrailerTailGet = (id) => async (dispatch) => {
  try {
    const { data, status } = await api.get(
      `${process.env.REACT_APP_API_URL}/wheel-maintenance-trailer/${id}`,
    );
    if (status === 200) {
      dispatch({ type: WHEELTRAILERTAIL_GET, payload: data });
    }
  } catch (error) {
    console.error(error);
    dispatch({ type: WHEELTRAILERTAIL_ERROR });
  }
};

export const wheelTrailerTailrPut = (id, payload) => async (dispatch) => {
  console.log('payload', payload);
  try {
    dispatch({ type: WHEELTRAILERTAIL_LOADING });
    const { data } = await api.put(
      `${process.env.REACT_APP_API_URL}/wheel-maintenance-trailer/${id}`,
      payload,
    );
    dispatch({ type: WHEELTRAILERTAIL_PUT, payload: data });
  } catch (error) {
    console.error(error);
    dispatch({ type: WHEELTRAILERTAIL_ERROR });
  }
};
export const wheelTrailerTailDelete = (id) => async (dispatch) => {
  try {
    dispatch({ type: WHEELTRAILERTAIL_LOADING });
    const { data } = await api.delete(
      `${process.env.REACT_APP_API_URL}/wheel-maintenance-trailer/${id}`,
    );
    dispatch({ type: WHEELTRAILERTAIL_DELETE, payload: data });
  } catch (error) {
    console.error(error);
    dispatch({ type: WHEELTRAILERTAIL_ERROR });
  }
};
